import { lazy, Suspense } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import { AuthProvider } from "@/hooks/useAuth";
import { LanguageProvider } from "@/hooks/useLanguage";
import { CartProvider } from "@/hooks/useCart";
import Index from "./pages/Index.tsx";
import ScrollToTop from "./components/ScrollToTop.tsx";
import CanonicalUrl from "./components/CanonicalUrl.tsx";

// Lazy load non-critical routes
const ParMums = lazy(() => import("./pages/ParMums.tsx"));
const Kondicionieri = lazy(() => import("./pages/Kondicionieri.tsx"));
const Apkure = lazy(() => import("./pages/Apkure.tsx"));
const Ventilacija = lazy(() => import("./pages/Ventilacija.tsx"));
const Projektesana = lazy(() => import("./pages/Projektesana.tsx"));
const Serviss = lazy(() => import("./pages/Serviss.tsx"));
const Konsultacijas = lazy(() => import("./pages/Konsultacijas.tsx"));
const AdminLogin = lazy(() => import("./pages/AdminLogin.tsx"));
const AdminDashboard = lazy(() => import("./pages/AdminDashboard.tsx"));
const Projekti = lazy(() => import("./pages/Projekti.tsx"));
const ProjektaLapa = lazy(() => import("./pages/ProjektaLapa.tsx"));
const Kontakti = lazy(() => import("./pages/Kontakti.tsx"));
const NotFound = lazy(() => import("./pages/NotFound.tsx"));

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <AuthProvider>
      <LanguageProvider>
        <CartProvider>
          <TooltipProvider>
            <Toaster />
            <Sonner />
            <BrowserRouter>
              <ScrollToTop />
              <CanonicalUrl />
              <Suspense fallback={<div className="min-h-screen" />}>
                <Routes>
                  <Route path="/" element={<Index />} />
                  <Route path="/par-mums" element={<ParMums />} />
                  <Route path="/kondicionieri" element={<Kondicionieri />} />
                  <Route path="/apkure" element={<Apkure />} />
                  <Route path="/ventilacija" element={<Ventilacija />} />
                  <Route path="/projektesana" element={<Projektesana />} />
                  <Route path="/serviss" element={<Serviss />} />
                  <Route path="/konsultacijas" element={<Konsultacijas />} />
                  <Route path="/kontakti" element={<Kontakti />} />
                  <Route path="/admin" element={<AdminLogin />} />
                  <Route path="/admin/dashboard" element={<AdminDashboard />} />
                  <Route path="/projekti" element={<Projekti />} />
                  <Route path="/projekti/:slug" element={<ProjektaLapa />} />
                  {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
                  <Route path="*" element={<NotFound />} />
                </Routes>
              </Suspense>
            </BrowserRouter>
          </TooltipProvider>
        </CartProvider>
      </LanguageProvider>
    </AuthProvider>
  </QueryClientProvider>
);

export default App;
